import axios from 'axios';
import { API_url } from '../api.setup';
import { ServicePriceModel } from 'src/models/price/sevicePrice';
import { enqueueSnackbar } from 'notistack';

const API_Controller = '/ServicePrices';

export const ServicePriceServices = {
  getAllData: async () => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/getallServicePrices`
      );
      return response.data as ServicePriceModel[];
    } catch (error) {
      throw error;
    }
  },

  getAllServicePricesCityIdServiceIdCarcategoryId: async (
    cityId,
    serviceId,
    carCategoryId
  ) => {    
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/GetServicePrice?cityId=${cityId}&serviceId=${serviceId}&carcategoryId=${carCategoryId}`
      );
      return response.data as ServicePriceModel;
    } catch (error) {
      throw error;
    }
  },

  getData: async (dataId) => {
    try {
      const response = await axios.get(
        `${API_url}/getallServicePrices/get?id=${dataId}`
      );
      return response.data as ServicePriceModel[];
    } catch (error) {
      throw error;
    }
  },

  addData: async (dataToAdd: ServicePriceModel) => {
    const reModel = {
      cityId: dataToAdd.cityId,
      serviceId: dataToAdd.serviceId,
      listOfPrices: dataToAdd.listOfPrices.map((data) => ({
        carCategoryId: data.carCategoryId,
        amount: data.amount
      })),
      StartDateTime: dataToAdd.startDateTime,
      EndDateTime: dataToAdd.endDateTime,
      IsActive: dataToAdd.isActive
    };
    try {
      
      const response = await axios.post(
        `${API_url}${API_Controller}/AddBulkServicePricesForCityAndService`,
        reModel
      );
      enqueueSnackbar(`Service ${dataToAdd.cityId} Added Successfully`, {
        variant: 'success'
      });
      return response.data as ServicePriceModel[];
    } catch (error) {
      throw error;
    }
  },

  addSingleData: async (dataToAdd) => {
    try {
      const respons = await axios.post(
        `${API_url}${API_Controller}/create`,
        dataToAdd
      );
      enqueueSnackbar(`Service price updated Successfully`, {
        variant: 'success'
      });
      return respons.data as ServicePriceModel[];
    } catch (error) {
      throw error;
    }
  },

  editData: async (dataToAdd) => {
    const reModel = {
      id: dataToAdd.id,
      amount: dataToAdd.amount,
      cityId: dataToAdd.cityId,
      serviceId: dataToAdd.serviceId,
      carCategoryId: dataToAdd.carCategoryId,
      startDateTime: dataToAdd.startDateTime,
      endDateTime: dataToAdd.endDateTime,
      isActive: dataToAdd.isActive
    };
    try {
      const respons = await axios.put(
        `${API_url}${API_Controller}/update`,
        reModel
      );
      enqueueSnackbar(`Service price Edited Successfully`, {
        variant: 'success'
      });
      return respons.data as ServicePriceModel[];
    } catch (error) {
      throw error;
    }
  },

  deleteAllData: async (serviceId, cityId, data) => {
    try {
      const response = await axios.delete(
        `${API_url}${API_Controller}/DeleteAllPricesForService?serviceId=${serviceId}&cityId=${cityId}`
      );
      enqueueSnackbar(`Service prices ${data.itemName} deleted Successfully`, {
        variant: 'success'
      });
      return response.data as ServicePriceModel[];
    } catch (error) {
      enqueueSnackbar(`Service prices ${data.itemName} delete unsuccessfully`, {
        variant: 'error'
      });
      throw error;
    }
  }
};
